/* eslint-disable @typescript-eslint/naming-convention */
import { NgModule } from '@angular/core';
import { FeatherModule } from 'angular-feather';
import {
  Search,
  MapPin,
  ExternalLink,
  Star,
  Sliders,
  ArrowLeft,
  Facebook,
  Twitter,
  Home,
  MessageSquare,
  Check,
  ChevronDown,
  ChevronUp,
  HelpCircle,
  AlertCircle,
  Calendar,
  Instagram,
  Menu,
  LogOut,
  LogIn,
  User,
  Info,
  AlertOctagon,
  CheckCircle,
  UserPlus,
  XCircle,
  Copy,
  ChevronRight,
  Gift,
  Key,
  ShoppingCart,
  PhoneCall,
  ChevronLeft,
  ArrowLeftCircle,
  ArrowRightCircle
} from 'angular-feather/icons';

const icons = {
  Search,
  MapPin,
  ExternalLink,
  Star,
  Sliders,
  ArrowLeft,
  Facebook,
  Twitter,
  Home,
  MessageSquare,
  Check,
  ChevronDown,
  ChevronUp,
  HelpCircle,
  AlertCircle,
  Calendar,
  Instagram,
  Menu,
  LogOut,
  LogIn,
  User,
  Info,
  AlertOctagon,
  CheckCircle,
  UserPlus,
  XCircle,
  Copy,
  ChevronRight,
  Gift,
  Key,
  ShoppingCart,
  PhoneCall,
  ChevronLeft,
  ArrowLeftCircle,
  ArrowRightCircle
};

@NgModule({
  imports: [
    FeatherModule.pick(icons)
  ],
  exports: [
    FeatherModule
  ]
})
export class IconsModule { }
